import { useData } from 'resift';
import makeGetSource from 'fetches/makeGetSource';

function useSource(sourceId: string) {
  const getSource = makeGetSource(sourceId);
  const source = useData(getSource);

  return source;
}

export default useSource;
